// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__CkIiG","wrapper__title":"Error_wrapper__title__JeHTy","wrapper__subtitle":"Error_wrapper__subtitle__n22Yp","wrapper__button":"Error_wrapper__button__XZH3t"};